import { css } from "@emotion/css"
import { getDay } from "date-fns"

import { useSetOf } from "./useSetOf"
import { Day } from "./Day"

const days_of_week = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"] as const
export type DayOfWeek = (typeof days_of_week)[number]

export function getDayOfWeek(d: Date): DayOfWeek {
  const i = getDay(d)
  return days_of_week[i]
}

const days: DayOfWeek[] = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"]

type DaysOfWeekProps = {
  isDaySelected: (d: DayOfWeek) => boolean
  onDayChange: (d: DayOfWeek) => void
  disabled?: boolean
}

export function DaysOfWeek(props: DaysOfWeekProps) {
  const { isDaySelected, onDayChange, disabled = false } = props
  return (
    <div
      className={css`
        --w: 40px;
        --h: 32px;
        display: grid;
        grid-template-columns: repeat(7, var(--w));
        gap: var(--spacing-xs, 8px);
        width: min-content;
      `}
    >
      {days.map((day) => {
        return (
          <Day
            key={day}
            day={day}
            onDayChange={onDayChange}
            isSelected={isDaySelected(day)}
            display={(d) => d.substring(0, 1)}
            disabled={disabled}
          />
        )
      })}
    </div>
  )
}

export function useDaysOfWeek(initial: DayOfWeek) {
  const s = useSetOf<DayOfWeek>(initial)
  return {
    isDayOfWeekSelected: s.isSelected,
    onDayOfWeekChange: s.setItem,
    resetDaysOfWeek: s.resetItems,
    getDaysOfWeek: s.toArray,
  }
}
